const DEFAULT_LIN_UPLOAD_FILE_NAME = 'supervisor-sandbox-input.json';

export function toJsonUploadFileName(originalFileName?: string): string {
  const trimmed = originalFileName?.trim();
  if (!trimmed) {
    return DEFAULT_LIN_UPLOAD_FILE_NAME;
  }

  if (trimmed.toLowerCase().endsWith('.json')) {
    return trimmed;
  }

  const withoutExtension = trimmed.replace(/\.[^/.]+$/, '');
  return `${withoutExtension || 'supervisor-sandbox-input'}.json`;
}

export function buildSupervisorLinUploadFile(
  sanitizedInput: unknown,
  originalFileName?: string,
): File {
  return new File(
    [JSON.stringify(sanitizedInput, null, 2)],
    toJsonUploadFileName(originalFileName),
    {
      type: 'application/json',
    },
  );
}
